export default  {
  names: {
    uploadItem: 'item',
    select: 'default',
    selectDrag: 'select-drag',
    selectDragExtra: 'select-drag-extra',
  }
};